import { useRoutes } from 'react-router-dom';

// routes
import AuthenticationRoutes from './AuthenticationRoutes';
import { isLoggedInOrNot } from 'src/utils/loggedInStatus.utils';
import StudentRoutes from './StudentRoutes';
import ParentRoute from './ParentRoutes';
import { Cookies } from 'react-cookie';
import { LoginType } from 'src/enums';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const isLoggedIn = isLoggedInOrNot();
  const cookies = new Cookies();

  if (isLoggedIn) {
    if (cookies.get('logged_in_type') === String(LoginType.STUDENT)) {
      return useRoutes([...StudentRoutes, ...AuthenticationRoutes]);
    } else {
      return useRoutes([...ParentRoute, ...AuthenticationRoutes]);
    }
  } else {
    return useRoutes([...AuthenticationRoutes]);
  }
}
